import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosStudentInstance from "../../axiosStudentInstance.js";

export const fetchFavoriteTeachers = createAsyncThunk(
  "studentFavorites/fetch",
  async (_, thunkAPI) => {
    try {
      const res = await axiosStudentInstance.get("/student/favorites");

      return res.data;
      // eslint-disable-next-line no-unused-vars
    } catch (err) {
      // console.log(err);

      return thunkAPI.rejectWithValue("Failed to load favorites");
    }
  }
);

export const addFavoriteTeacher = createAsyncThunk(
  "studentFavorites/add",
  async (teacher, thunkAPI) => {
    try {
      await axiosStudentInstance.post(`/student/favorites/${teacher.id}`);
      // console.log(teacher);

      return teacher; // teacher = { id, name, avatar, ... }
      // eslint-disable-next-line no-unused-vars
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to add");
    }
  }
);

export const removeFavoriteTeacher = createAsyncThunk(
  "studentFavorites/remove",
  async (teacherId, thunkAPI) => {
    try {
      await axiosStudentInstance.delete(`/student/favorites/${teacherId}`);
      // console.log(teacherId);

      return teacherId;
      // eslint-disable-next-line no-unused-vars
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to remove");
    }
  }
);
